<template>
  <b-form id="payout-form">
    <label for="accountholder-name">Account Holder Name</label>
    <b-form-input
      id="accountholder-name"
      name="accountholder-name"
      v-model="form.account_name"
      placeholder="John Smith"
      required
    ></b-form-input>

    <b-row class="mt-3">
      <b-col>
        <label for="accountholder-bsb">BSB</label>
        <b-form-input
          id="accountholder-bsb"
          name="accountholder-bsb"
          v-model="form.account_bsb"
          placeholder="BSB"
          v-mask="'######'"
          required
        ></b-form-input>
      </b-col>
      <b-col>
        <label for="accountholder-number">Account Number</label>
        <b-form-input
          id="accountholder-number"
          name="accountholder-number"
          v-model="form.account_number"
          placeholder="Account Number"
          v-mask="'#########'"
          required
        ></b-form-input>
      </b-col>
    </b-row>

    <div id="error-message" class="invalid-feedback d-block mt-3" role="alert">
      {{ errorMessage }}
    </div>

    <hr class="modal-divider mt-5 mb-4" />

    <div class="text-right mb-3">
      <b-button
        class="btn-action btn-outlined bg-white text-dark mr-3"
        variant="outline-secondary"
        @click="resetForm"
        >Discard</b-button
      >

      <b-button
        id="submit-button"
        class="btn-action"
        variant="primary"
        :disabled="loading"
        @click="submitBankAccount"
      >
        <b-spinner class="mr-2" small v-if="loading"></b-spinner>Save
      </b-button>
    </div>
  </b-form>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'

export default {
  props: {
    fullName: {
      type: String
    },
    accountId: {
      type: String
    }
  },

  data() {
    return {
      loading: false,
      errorMessage: null,
      form: {
        account_name: this.fullName,
        account_bsb: null,
        account_number: null
      }
    }
  },

  methods: {
    ...mapActions({
      createExternalAccount: 'account/createExternalAccount'
    }),

    resetForm() {
      this.form.account_name = this.fullName
      this.form.account_bsb = null
      this.form.account_number = null
    },

    async submitBankAccount() {
      this.loading = true

      let formData = []
      const details = {
        country: 'AU',
        currency: 'aud',
        account_holder_name: this.form.account_name,
        account_holder_type: 'individual',
        routing_number: this.form.account_bsb,
        account_number: this.form.account_number
      }
      for (let property in details) {
        let encodedKey = encodeURIComponent(property)
        let encodedValue = encodeURIComponent(details[property])
        formData.push('bank_account[' + encodedKey + ']=' + encodedValue)
      }

      /**
       * Get bank account token
       */
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${this.$env.stripePublishableKey}`
      }
      await axios
        .post('https://api.stripe.com/v1/tokens', formData.join('&'), {
          headers: headers
        })
        .then(({ data }) => {
          this.createBankAccount(data.id)
        })
        .catch(err => {
          const data = err.response.data

          if (data.error.code === 'routing_number_invalid') {
            this.errorMessage = 'Invalid BSB.'
          } else if (data.error.code === 'account_number_invalid') {
            this.errorMessage = 'Invalid account number.'
          }
          this.loading = false
        })
    },

    async createBankAccount(token) {
      await this.createExternalAccount({
        external_account: token
      }).then(() => {
        this.$emit('onSuccess')
      })
      this.loading = false
    }
  }
}
</script>

<style>
.btn-action {
  min-width: 150px;
}
</style>
